const REGION_COOKIE = "ak_rg";
const COUNTRY_COOKIE = "ak_co";
const EXPERIENCE_COOKIE = "exp_pref";

const exported = {
    REGION_COOKIE,
    COUNTRY_COOKIE,
    EXPERIENCE_COOKIE,
};

export default exported;
export { REGION_COOKIE, COUNTRY_COOKIE, EXPERIENCE_COOKIE };
